<script setup lang="ts">
import type { SensorViewValues } from '../../models/sensorViewValues';
import { convertValue, extractMeta } from '../../utilities/utils';
import RadiatorWidget from '../../widgets/Radiator';
import { computed } from 'vue';
import type { PropType } from 'vue';

type Value = {
  name: string;
  value: number;
  unit: string;
}

const props = defineProps({
  viewValues: {
    type: Object as PropType<SensorViewValues>,
    required: true,
  },
});

const temp = computed(() => props.viewValues.values.filter((v) => v.type === 'temp'));

const params = computed(() => ({
  tempValues: temp.value.map(convertValue) as Value[],
  meta: extractMeta(props.viewValues)
}));
</script>

<template>
  <RadiatorWidget v-bind="params" />
</template>
